/* eslint-disable no-console */
import { katalLogger } from '@flexible-reports/services/logger/katalLogger';

const isProduction = (): boolean => process.env.NODE_ENV === 'production';

/**
 * The log functions in this module emits messages to Katal. All UI code must
 * use the functions in this library.
 */

/**
 * Logs an info message.
 * @param message the info message
 * @param optionalParams any other objects to be logged
 */
const logInfoMessage = (message: string, ...optionalParams: any[]): void => {
  if (isProduction()) {
    katalLogger.info(message, ...optionalParams);
  } else {
    console.log(message, ...optionalParams);
  }
};

/**
 * Logs a warning message.
 * @param message the warning message
 * @param optionalParams any other objects to be logged
 */
const logWarningMessage = (message: string, ...optionalParams: any[]): void => {
  if (isProduction()) {
    katalLogger.warn(message, ...optionalParams);
  } else {
    console.warn(message, ...optionalParams);
  }
};

/**
 * Logs an error message.
 * @param message the error message
 * @param optionalParams any other objects to be logged
 */
const logErrorMessage = (message: string, ...optionalParams: any[]): void => {
  if (isProduction()) {
    katalLogger.error(message, ...optionalParams);
  } else {
    console.error(message, ...optionalParams);
  }
};

/**
 * Logs a fatal message.
 * @param message the fatal message
 * @param optionalParams any other objects to be logged
 */
const logFatalMessage = (message: string, ...optionalParams: any[]): void => {
  if (isProduction()) {
    katalLogger.fatal(message, ...optionalParams);
  } else {
    console.error('[FATAL]', message, ...optionalParams);
  }
};

export default {
  logWarningMessage,
  logErrorMessage,
  logInfoMessage,
  logFatalMessage
};
